// Scroll lock
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Menu = () => {
  const buttons = document.querySelectorAll('.js-menu-toggle');
  const dropDownMenus = document.querySelectorAll('#header-nav .sub-menu');
  const dropDownItems = document.querySelectorAll(
    '#header-nav .menu-item-has-children > a, #header-nav .menu-item-has-children > span'
  );
  const headerNav = document.getElementById('header-nav');
  const menu = document.querySelector('#header-nav .navbar-nav');

  // Hide Menu
  // menu.classList.add('hidden');

  // Hide dropdown menus
  for (const dropDownMenu of dropDownMenus) {
    dropDownMenu.classList.add('hidden');
  }

  // Toggle Menu
  buttons.forEach((el) => {
    el.addEventListener('click', () => {
      // Toggle the hide class on menu
      // menu.classList.add('hidden');
      menu.classList.toggle('active');

      // Add is-open class to Nav
      headerNav.classList.toggle('menu-is-open');

      if (!headerNav.classList.contains('menu-is-open')) {
        enableBodyScroll(menu);
      } else {
        disableBodyScroll(menu);
      }
    });
  });

  // Append clickable span tags to menu items with children
  for (const dropDownItem of dropDownItems) {
    let span = document.createElement('span');
    dropDownItem.appendChild(span);
  }

  // Loop through span tags to open/close dropdown menus
  const toggleIcons = document.querySelectorAll(
    '#header-nav .menu-item-has-children > a span, #header-nav .menu-item-has-children > span span, .js-open-submenu > span'
  );

  for (const toggleIcon of toggleIcons) {
    toggleIcon.innerHTML = '+';

    toggleIcon.addEventListener('click', (e) => {
      let subMenu = toggleIcon.parentNode.nextElementSibling;

      e.preventDefault();
      subMenu.classList.toggle('hidden');
      subMenu.classList.toggle('flex');
      toggleIcon.classList.toggle('is-open');

      if (toggleIcon.classList.contains('is-open')) {
        toggleIcon.innerHTML = '–';
      } else {
        toggleIcon.innerHTML = '+';
      }
    });
  }

  // Extra code added to enable click of item that is not a link to open submenu
  // @TODO: Needs to be dryer and integrated into the above functions. DH
  const noLinkElement = document.querySelectorAll('.js-open-submenu');

  noLinkElement.forEach((item) => {
    item.addEventListener('click', (event) => {
      let subMenu = item.nextElementSibling;
      let toggleIcon = item.querySelector('span');

      event.preventDefault();
      subMenu.classList.toggle('hidden');
      subMenu.classList.toggle('flex');

      toggleIcon.classList.toggle('is-open');

      if (toggleIcon.classList.contains('is-open')) {
        toggleIcon.innerHTML = '–';
      } else {
        toggleIcon.innerHTML = '+';
      }
    });
  });

  // Close menu on ESC key
  document.onkeydown = (e) => {
    if (e.key === 'Escape' && !menu.classList.contains('hidden')) {
      menu.classList.add('hidden');
    }
  };
};

export default Menu;
